<template>
  <div class="container">
    <el-row style="margin-bottom: 10px">
      <el-col :span="12" style="color: #028D66">
        <span style="margin-right: 20px">
          项目ID:{{ project_id }}
        </span>
        <span>
          项目名称：{{ project_name }}
        </span>
      </el-col>
    </el-row>
    <!--搜索-->
    <search-filter :form-config="searchConfig" :model="query" @search="search" @reset="reset"></search-filter>
    <!--列表-->
    <div v-loading="isLoading" class="photo-grid">
      <el-card v-for="item in tableData" :key="item.site_id" class="photo-card" :body-style="{ padding: '0' }">
        <div class="photo-container" @click="previewPic(item)">
          <img :src="item.url" class="photo-image">
        </div>
        <div class="photo-info">
          <div class="info-row">
            <span class="label">场所ID:</span>
            <span class="value">{{ item.site_id }}</span>
          </div>
          <div class="info-row">
            <span class="label">主位置:</span>
            <span class="value">{{ item.location1 }}</span>
          </div>
          <div class="info-row">
            <span class="label">详细位置:</span>
            <span class="value">{{ item.location2 }}</span>
          </div>
          <div class="info-row">
            <span class="label">创建人:</span>
            <span class="value">{{ item.uploaded_time }}</span>
          </div>
          <div class="info-row">
            <span class="label">创建时间:</span>
            <span class="value">{{ item.uploaded_time }}</span>
          </div>
        </div>
      </el-card>
    </div>
    <!--分页-->
    <div class="pagination-container">
      <el-pagination @size-change="changePageSize" @current-change="changePage"
        :current-page.sync="pagination.current_page" :page-size="pagination.per_page" :page-sizes="[12, 16, 24, 36]"
        layout="total, sizes, prev, pager, next, jumper" :total="pagination.total" background>
      </el-pagination>
    </div>
    <!--预览图片-->
    <el-dialog :visible.sync="pictureModel.dialogVisible" :modal="false" v-model="pictureModel" title="图片预览"
      width="50%">
      <img :src="pictureModel.previewpic" alt="" width="100%" />
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="pictureModel.dialogVisible = false">确定</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
export default {
  data() {
    return {
      project_id: '',
      project_name: '',
      is_admin: false,
      isLoading: true,
      tableData: [],
      query: { site_id: "" },
      pagination: { current_page: 1, total: 1, per_page: 16 },
      searchConfig: [
        { key: "site_id", label: "场所ID", type: "input" },
      ],
      pictureModel: {
        dialogVisible: false,
        previewpic: '',
      },
      exportModel: {
        dialogVisible: false,
      },
      cards: [],
      cardRows: []
    }
  },
  methods: {
    //预览图片
    previewPic(row) {
      this.pictureModel.previewpic = row.url
      this.pictureModel.dialogVisible = true
    },
    async getList() {
      this.isLoading = true;
      try {
        let params = {
          project_id: this.project_id,
          ...this.query,
          ...this.pagination
        }
        let res = await this.$Api.post('get_rhzp_list', params)
        if (res) {
          this.pagination = {
            current_page: res.current_page,
            total: res.total,
            per_page: res.per_page
          }
          this.tableData = res.data
        }
      } catch (e) {
        this.$message.error(e.errormsg)
      } finally {
        this.isLoading = false;
      }
    },
    search() {
      this.getList()
    },
    reset() {
      this.query = { site_id: "" }
      this.pagination = {
        current_page: 1,
        total: 1,
        per_page: 16
      }
      this.getList()
    },
    changePageSize(size) {
      this.pagination.per_page = size;
      this.getList();
    },
    changePage() {
      this.getList();
    },
    async getProject() {
      try {
        let res = await this.$Api.post('get_project', { project_id: this.project_id })
        if (res) {
          this.project_name = res.project_name
        }
      } catch (e) {
        this.$message.error(e.errormsg)
      }
    },
    async getProjectRole() {
      try {
        let res = await this.$Api.post('get_project_role', { project_id: this.project_id })
        if (res) {
          if (res.is_admin) {
            this.is_admin = true
          }
        }
      } catch (e) {
        this.$message.error(e.errormsg)
      }
    },
  },
  created() {
    this.project_id = this.$route.params.project_id
    this.getProject()
    this.getList()
    this.getProjectRole()
  }
}
</script>

<style lang="scss" scoped>
.pagination-container {
  display: flex;
  justify-content: center;
  margin: 30px 0 20px;
}

// Style the pagination component
:deep(.el-pagination) {
  padding: 10px 20px;
  border-radius: 8px;
  background-color: #f9f9f9;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);

  .el-pagination__total,
  .el-pagination__sizes {
    margin-right: 15px;
  }

  .btn-prev,
  .btn-next,
  .el-pager li {
    background-color: white;
    border: 1px solid #ebeef5;
    transition: all 0.2s;

    &:hover,
    &.active {
      color: #028D66;
      border-color: #028D66;
    }
  }

  .el-pagination__jump {
    margin-left: 15px;
  }
}

.photo-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 20px;
  margin-top: 20px;
}

.photo-card {
  transition: transform 0.3s;

  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
  }
}

.photo-container {
  height: 200px;
  overflow: hidden;
  cursor: pointer;
}

.photo-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.3s;

  &:hover {
    transform: scale(1.05);
  }
}

.photo-info {
  padding: 14px;
  background-color: #f9f9f9;
}

.info-row {
  display: flex;
  margin-bottom: 5px;
  font-size: 13px;

  .label {
    color: #606266;
    width: 70px;
    flex-shrink: 0;
  }

  .value {
    color: #303133;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}

.search-filter {
  margin: 12px 0;
  border: 1px solid #028D66;
  padding: 24px 0 0 24px;
  background-color: #ffffff;
}



.search-filter {
  margin: 12px 0;
  border: 1px solid #028D66;
  padding: 24px 0 0 24px;
  background-color: #ffffff;
}

.card-row {
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
}

.box-card {
  width: 23%;
}

.content-row {
  margin-bottom: 10px;
  /* 在行与行之间添加一些间距 */
}

.card-content {
  padding: 20px;
  text-align: center;
  font-size: 16px;
  font-weight: bold;
}

.download-button {
  text-align: center;
}
</style>
